import { useState, useEffect } from 'react';
import { notify } from '../utils/utils';
import { Fetch } from '../services/api';



export const useImagenaTexto = () => {
    const [ textoConvertido, setTextoConvertido ] = useState({});
    const [ loadingConversion , setLoadingConversion ] = useState(false)

    const extraerTexto = async (urlImagen) => {
        setLoadingConversion(true);
      
        try {
          const response = await Fetch({
            url: "https://imagentotext.abexa.pe/extraer-texto",
            method: "POST",
            body: JSON.stringify({
              url: urlImagen,
            }),
            typeResponse: "json",
          });
      
          setLoadingConversion(false);
      
          if (response && response.isValid) {
            setTextoConvertido(response);
          } else {
            notify(response.error || "Error inesperado", "error");
          }
        } catch (error) {
          console.error("Error al hacer la solicitud:", error);
          notify("Error en la solicitud", "error");
        }
      };
    

    return {
        extraerTexto,
        textoConvertido,
        loadingConversion,
    }

}